import { render, staticRenderFns } from "./ModalQuestions.vue?vue&type=template&id=4d88a2b1&scoped=true&"
import script from "./ModalQuestions.vue?vue&type=script&lang=js&"
export * from "./ModalQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ModalQuestions.vue?vue&type=style&index=0&id=4d88a2b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d88a2b1",
  null
  
)

export default component.exports